/**
 * Check git history on this component if adding back the ability to match a candidate
 * to a vacancy from the hired list.
 */
const HiredCandidateRow = ({ candidate }) => (
  <div className="hired-candidate-row flex">{candidate.name}</div>
);

export default HiredCandidateRow;
